import { render, staticRenderFns } from "./AiAllPurposeQuestion.vue?vue&type=template&id=5fe3ac80&"
import script from "./AiAllPurposeQuestion.vue?vue&type=script&lang=js&"
export * from "./AiAllPurposeQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
